/* eslint-disable react/no-unused-state */
/* eslint-disable no-undef */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React, { useState, useRef } from 'react';
import Modal from '@mui/material/Modal';
import { Button } from '@mui/material';
import './ShareEventButton.css';

function ShareEventModal(props) {
  const linkRef = useRef(null);
  const [showAlert, setShowAlert] = useState(false);
  const copyLink = () => {
    const linkElement = linkRef.current;

    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(linkElement.value)
        .then(() => {
          setShowAlert(true);

          setTimeout(() => {
            setShowAlert(false);
          }, 3000);
        })
        .catch((err) => {
          console.error('Could not copy text: ', err);
        });
    } else {
      linkElement.select();
      document.execCommand('copy');
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
    }
  };

  const URL = 'http://localhost:3000';
  const prodURL = 'https://app.fayven.com';
  const testURL = 'https://app.dev.fayven.com';

  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <div className="modal-container">
        <Button size="small" className="action-button2" onClick={props.handleClose}>
          X
        </Button>
        <h2 className="title" id="modal-modal-title">
          Share Event Link
        </h2>
        <p className="description" id="modal-modal-description">
          Share this link directly with vendors so they can apply.
        </p>
        <input
          type="text"
          value={`${process.env.REACT_APP_STAGE === 'dev' ? testURL : prodURL}/app/event/${
            props.eventId
          }`}
          readOnly
          ref={linkRef}
          className="event-link"
        />
        <Button
          variant="contained"
          style={{
            borderRadius: '3.125rem',
            background: '#0b97ba',
            display: 'flex',
            padding: '1.0625rem 1.5rem',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '0.625rem',
          }}
          onClick={copyLink}>
          Copy Link
        </Button>
        {showAlert && <div className="copied-alert">Link copied to clipboard!</div>}
      </div>
    </Modal>
  );
}

export default ShareEventModal;
